import { defineMessages } from 'react-intl';

const messages = defineMessages({
  a11yBodyPolicyLink: {
    id: 'a11yBodyPolicyLink',
    defaultMessage: 'Website Accessibility Policy',
    description: 'Title for link to full accessiblity policy.',
  },
  a11yBodyPageHeader: {
    id: 'a11yBodyPageHeader',
    defaultMessage: 'Individualized Accessibility Process for Course Creators',
    description: 'Heading for studio\'s accessibility policy page.',
  },
  a11yBodyIntroGraph: {
    id: 'a11yBodyIntroGraph',
    defaultMessage: 'At edX, we seek to understand and respect the unique needs and perspectives of the edX global community.  We value every course team and are committed to being a leader in expanding access to all, including course team creators and authors with disabilities.  To that end, we have adopted a {communityAccessibilityElement} and this process to ensure that course team creators and authors with disabilities are able to develop and post content on our platform via Studio.',
    description: 'Introductory paragraph outlining why we care about accessiblity, and what we\'re doing about it.',
  },
  a11yBodyStepsHeader: {
    id: 'a11yBodyStepsHeader',
    defaultMessage: 'Course team creators and authors who, because of their disabilities, need assistance to use Studio should take the following steps:',
    description: 'Heading for list of steps authors can take for accessiblity requests.',
  },
  a11yBodyEdxResponse: {
    id: 'a11yBodyEdxResponse',
    defaultMessage: 'We will communicate with you about your preferences and needs in determining the appropriate solution, although the ultimate decision will be ours, provided that the solution is effective and timely.  The factors we will consider in choosing an accessibility solution are: effectiveness; timeliness (relative to your deadlines); ease of implementation; and ease of use for you.  We will notify you of the decision and explain the basis for our decision within 10 business days of discussing with you.',
    description: 'Paragraph outlining how we will select an accessibility solution.',
  },
  a11yBodyEdxFollowUp: {
    id: 'a11yBodyEdxFollowUp',
    defaultMessage: 'Thereafter, we will communicate with you on a weekly basis regarding our evaluation, decision, and progress in implementing the accessibility solution.  We will notify you when implementation of your accessibility solution is complete and will follow-up with you as may be necessary to see if the solution was effective.',
    description: 'Paragraph outlining how we will follow-up with you during and after implementing an accessibility solution.',
  },
  a11yBodyOngoingSupport: {
    id: 'a11yBodyOngoingSupport',
    defaultMessage: 'EdX will provide ongoing technical support as needed and will address any additional issues that arise after the initial course creation.',
    description: 'A statement of ongoing support.',
  },
  a11yBodyProcessContact: {
    id: 'a11yBodyProcessContact',
    defaultMessage: 'If you have any questions about this process, you may contact us at {emailElement} or {phoneNumber}.',
    description: 'Contact information heading for those with questions about the accessibility process.',
  },
  a11yBodyA11yFeedback: {
    id: 'a11yBodyA11yFeedback',
    defaultMessage: 'Please direct any questions or suggestions on how to improve the accessibility of Studio to {emailElement} or use the form below. We welcome your feedback.',
    description: 'Contact information heading for those with accessiblity issues or suggestions.',
  },
  a11yBodyEmailHeading: {
    id: 'a11yBodyEmailHeading',
    defaultMessage: 'Notify us by email addressed to {emailElement}.  In order for edX to fully and promptly assess and respond to your request, please provide the following information:',
    description: 'Heading for list of information required when you email us.',
  },
  a11yBodyNameEmail: {
    id: 'a11yBodyNameEmail',
    defaultMessage: 'Your name and email address;',
    description: 'Your contact information.',
  },
  a11yBodyInstitution: {
    id: 'a11yBodyInstitution',
    defaultMessage: 'The edX member institution that you are affiliated with;',
    description: 'edX affiliate information.',
  },
  a11yBodyBarrier: {
    id: 'a11yBodyBarrier',
    defaultMessage: 'A brief description of the challenge or barrier to access that you are experiencing; and',
    description: 'Accessibility problem information.',
  },
  a11yBodyTimeConstraints: {
    id: 'a11yBodyTimeConstraints',
    defaultMessage: 'How soon you need access and for how long (e.g., a planned course start date or in connection with a course-related deadline such as a final essay).',
    description: 'Time contstraint information.',
  },
  a11yBodyReceipt: {
    id: 'a11yBodyReceipt',
    defaultMessage: 'Within 48 business hours of receiving your request, the edX Support Team will respond to confirm receipt and forward your request to the edX Partner Manager for your institution and the edX Website Accessibility Coordinator.',
    description: 'Paragraph outlining what steps edX will take immediately.',
  },
  a11yBodyExtraInfo: {
    id: 'a11yBodyExtraInfo',
    defaultMessage: 'With guidance from the Website Accessibility Coordinator, edX will contact you within 5 business days to discuss your request and gather additional information from you to identify a solution.',
    description: 'Paragraph outlining how and when edX will reach out to you.',
  },
  a11yBodyFixesListHeader: {
    id: 'a11yBodyFixesListHeader',
    defaultMessage: 'EdX will assist you promptly and thoroughly so that you are able to create content on the CMS within your time constraints.  Such efforts may include, but are not limited to:',
    description: 'Heading for list of ways we might be able to assist.',
  },
  a11yBodyThirdParty: {
    id: 'a11yBodyThirdParty',
    defaultMessage: 'Purchasing a third-party tool or software for use on an individual basis to assist your use of Studio;',
    description: 'Buy third-party software.',
  },
  a11yBodyContractor: {
    id: 'a11yBodyContractor',
    defaultMessage: 'Engaging a trained independent contractor to provide real-time visual, verbal and physical assistance; or',
    description: 'Hire a contractor.',
  },
  a11yBodyCodeFix: {
    id: 'a11yBodyCodeFix',
    defaultMessage: 'Developing new code to implement a technical fix.',
    description: 'Make a technical fix.',
  },
});

export default messages;
